'use strict';

const jQuery = require('jquery');

const mediator = require('./../../../core/mediator');
const container = require('./../../../core/container');
const navigator = require('./../../navigator');
const transition = navigator.getTransition();
const transform = navigator.getTransform();

const close = function() {
    let menu = require('./');
    let $dropBack = container.get('$dropback');
    let $toolbar = container.get('$toolbar');
    let $menuWrapper = $toolbar.find('.cloud-nav-wrapper');

    $menuWrapper.removeClass('is-open');
    $toolbar.removeClass('opened-nav');
    $dropBack.addClass('d-none');

    menu.clear();
    $menuWrapper.removeClass('cloud-menu-plugin');
    $menuWrapper.find('.btn-close-menu').remove();
    mediator.publish('menu:ready', menu.add);
    mediator.publish('menu:close:after');

    return false;
};

const open = function(callback) {
    let $toolbar = container.get('$toolbar');
    let $handler;
    let $menuWrapper;
    let handlerStartEvent;
    let transitionDuration;
    let menuHeight;

    container.get('$dropback').removeClass('d-none');

    $menuWrapper = $toolbar.find('.cloud-nav-wrapper');
    menuHeight = $menuWrapper.outerHeight();
    transitionDuration = parseFloat($menuWrapper.css('transition-duration')) * 1000;

    $toolbar.addClass('opened-nav');

    setTimeout(function() {
        $handler = $toolbar.find('.menu-handler');
        $menuWrapper.addClass('is-open');
        $handler.on('touchstart MSPointerDown', function(e) {
            handlerStartEvent = e.originalEvent.touches[0].pageY;
            $menuWrapper.css('transition', 'none');

            $menuWrapper.on('touchmove MSPointerMove', function(event) {
                let positionY = (event.originalEvent.touches[0].pageY - handlerStartEvent);

                if (positionY > 0) {
                    $menuWrapper.css(transform, 'translate3d(0,' + positionY + 'px,0)');

                    if ((menuHeight - positionY) < 120) {
                        close();
                    }
                }
                event.preventDefault();
            });

            $handler.on('touchend MSPointerUp', function(e) {
                let positionY = $menuWrapper.css(transform).match(/ ([0-9]+)\)/i)[1];

                $handler.css('backgroundColor', '');

                if ((menuHeight - positionY) > 200) {
                    $menuWrapper.css(transition, '');
                    $menuWrapper.css(transform, 'translate3d(0,0,0)');
                } else {
                    close();
                }

                e.preventDefault();
            });
        });

        if (typeof callback === 'function') {
            callback();
        }
    }, transitionDuration);
};

const init = function() {
    container.get('$toolbar').find('.cloud-menu').on('touchstart MSPointerDown', function() {
        setTimeout(open, 300);
    });
    jQuery('<div id="cloud-dropback" class="d-none"></div>').insertAfter(container.get('$toolbar'));
    container.set('$dropback', jQuery('#cloud-dropback'));
    container.get('$dropback').on('touchend MSPointerUp', close);
};

const publish = function(html, item, data) {
    html.on('touchstart MSPointerDown', function() {
        if (container.get('$toolbar').find('.cloud-nav-wrapper').hasClass('is-open')) {
            let current = jQuery(this);
            let params = {
                    'target': current,
                    'params': data || {},
                };

            mediator.publish(item.eventName, params);

            return false;
        }
    });
};

module.exports.init = init;
module.exports.publish = publish;
module.exports.close = close;
module.exports.open = open;
